import React, { useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon, UserXIcon } from 'lucide-react';
export function UtentiNonAttivi() {
  const [searchTerm, setSearchTerm] = useState('');
  const [periodoInattivita, setPeriodoInattivita] = useState('6mesi');
  // Dati fittizi per la tabella
  const clientiInattivi = [{
    id: '1',
    ragioneSociale: 'Retail Fashion Srl',
    piva: '34567890121',
    ultimoAccesso: '15/11/2022',
    giorniInattivita: 187,
    abbonamentoAttivoDa: '18/01/2022',
    scadenzaAbbonamento: '18/01/2024',
    creditiDisponibili: 175,
    praticheAttive: 3,
    praticheSospese: 1
  }, {
    id: '2',
    ragioneSociale: 'Logistica Express Srl',
    piva: '78901234561',
    ultimoAccesso: '03/12/2022',
    giorniInattivita: 169,
    abbonamentoAttivoDa: '08/07/2022',
    scadenzaAbbonamento: '08/07/2023',
    creditiDisponibili: 68,
    praticheAttive: 4,
    praticheSospese: 0
  }, {
    id: '3',
    ragioneSociale: 'Arredamenti Design Srl',
    piva: '34567890122',
    ultimoAccesso: '20/01/2023',
    giorniInattivita: 121,
    abbonamentoAttivoDa: '05/09/2022',
    scadenzaAbbonamento: '05/09/2023',
    creditiDisponibili: 95,
    praticheAttive: 2,
    praticheSospese: 2
  }, {
    id: '4',
    ragioneSociale: 'Studio Legale Associato',
    piva: '45612378901',
    ultimoAccesso: '15/02/2023',
    giorniInattivita: 95,
    abbonamentoAttivoDa: '10/10/2022',
    scadenzaAbbonamento: '10/10/2023',
    creditiDisponibili: 120,
    praticheAttive: 5,
    praticheSospese: 0
  }, {
    id: '5',
    ragioneSociale: 'Elettronica Avanzata Srl',
    piva: '78956412301',
    ultimoAccesso: '10/03/2023',
    giorniInattivita: 72,
    abbonamentoAttivoDa: '15/12/2022',
    scadenzaAbbonamento: '15/12/2023',
    creditiDisponibili: 85,
    praticheAttive: 1,
    praticheSospese: 0
  }, {
    id: '6',
    ragioneSociale: 'Consulenza Finanziaria Spa',
    piva: '12378945601',
    ultimoAccesso: '25/03/2023',
    giorniInattivita: 57,
    abbonamentoAttivoDa: '03/11/2022',
    scadenzaAbbonamento: '03/11/2023',
    creditiDisponibili: 150,
    praticheAttive: 6,
    praticheSospese: 1
  }, {
    id: '7',
    ragioneSociale: 'Trasporti Veloci Srl',
    piva: '65498732101',
    ultimoAccesso: '12/04/2023',
    giorniInattivita: 39,
    abbonamentoAttivoDa: '22/08/2022',
    scadenzaAbbonamento: '22/08/2023',
    creditiDisponibili: 110,
    praticheAttive: 3,
    praticheSospese: 0
  }];
  // Filtraggio per termine di ricerca e periodo di inattività
  const filteredClienti = clientiInattivi.filter(cliente => cliente.ragioneSociale.toLowerCase().includes(searchTerm.toLowerCase()) || cliente.piva.includes(searchTerm)).filter(cliente => {
    switch (periodoInattivita) {
      case '1mese':
        return cliente.giorniInattivita >= 30;
      case '3mesi':
        return cliente.giorniInattivita >= 90;
      case '6mesi':
        return cliente.giorniInattivita >= 180;
      case '1anno':
        return cliente.giorniInattivita >= 365;
      default:
        return true;
    }
  });
  return <div className="space-y-6 pb-16" data-id="element-1695">
      <div data-id="element-1696">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1697">
          Utenti Non Attivi
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1698">
          Clienti che non accedono al sistema da lungo tempo
        </p>
      </div>
      <div className="bg-white shadow rounded-lg" data-id="element-1699">
        <div className="px-4 py-5 sm:p-6" data-id="element-1700">
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-between mb-4" data-id="element-1701">
            <div className="relative flex-1 max-w-md" data-id="element-1702">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1703">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1704" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm" placeholder="Cerca per ragione sociale, P.IVA..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1705" />
            </div>
            <div className="flex space-x-2" data-id="element-1706">
              <select value={periodoInattivita} onChange={e => setPeriodoInattivita(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm rounded-md" data-id="element-1707">
                <option value="1mese" data-id="element-1708">Inattivi da 1 mese</option>
                <option value="3mesi" data-id="element-1709">Inattivi da 3 mesi</option>
                <option value="6mesi" data-id="element-1710">Inattivi da 6 mesi</option>
                <option value="1anno" data-id="element-1711">Inattivi da 1 anno</option>
              </select>
              <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-1712">
                <DownloadIcon className="h-4 w-4 mr-2" data-id="element-1713" />
                Esporta
              </button>
            </div>
          </div>
          {filteredClienti.length === 0 ? <div className="text-center py-10" data-id="element-1714">
              <UserXIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1715" />
              <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-1716">
                Nessun utente inattivo trovato
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-1717">
                Non ci sono utenti inattivi per il periodo selezionato.
              </p>
            </div> : <div className="overflow-x-auto" data-id="element-1718">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1719">
                <thead className="bg-gray-50" data-id="element-1720">
                  <tr data-id="element-1721">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1722">
                      Ragione Sociale
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1723">
                      P.IVA
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1724">
                      Ultimo Accesso
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1725">
                      Giorni Inattività
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1726">
                      Scadenza Abbonamento
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1727">
                      Crediti Disponibili
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1728">
                      Pratiche
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1729">
                      Azioni
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1730">
                  {filteredClienti.map(cliente => <tr key={cliente.id} className="hover:bg-gray-50" data-id="element-1731">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1732">
                        <div className="text-sm font-medium text-gray-900" data-id="element-1733">
                          {cliente.ragioneSociale}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1734">
                        <div className="text-sm text-gray-500" data-id="element-1735">
                          {cliente.piva}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1736">
                        <div className="text-sm text-gray-500" data-id="element-1737">
                          {cliente.ultimoAccesso}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1738">
                        <div className={`text-sm font-medium ${cliente.giorniInattivita > 180 ? 'text-red-600' : cliente.giorniInattivita > 90 ? 'text-amber-600' : 'text-gray-500'}`} data-id="element-1739">
                          {cliente.giorniInattivita} giorni
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1740">
                        <div className="text-sm text-gray-500" data-id="element-1741">
                          {cliente.scadenzaAbbonamento}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1742">
                        <div className="text-sm font-medium text-green-600" data-id="element-1743">
                          {cliente.creditiDisponibili}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1744">
                        <div className="text-sm text-gray-500" data-id="element-1745">
                          <span className="font-medium" data-id="element-1746">
                            {cliente.praticheAttive}
                          </span>{' '}
                          attive,{' '}
                          <span className="text-amber-600" data-id="element-1747">
                            {cliente.praticheSospese}
                          </span>{' '}
                          sospese
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1748">
                        <a href="#" className="text-[#1A3E5C] hover:text-[#15324a] mr-4" data-id="element-1749">
                          Contatta
                        </a>
                        <a href="#" className="text-[#1A3E5C] hover:text-[#15324a]" data-id="element-1750">
                          Dettagli
                        </a>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
          <div className="mt-4 flex items-center justify-between" data-id="element-1751">
            <div data-id="element-1752">
              <p className="text-sm text-gray-700" data-id="element-1753">
                Visualizzazione{' '}
                <span className="font-medium" data-id="element-1754">{filteredClienti.length}</span> di{' '}
                <span className="font-medium" data-id="element-1755">{clientiInattivi.length}</span>{' '}
                clienti inattivi
              </p>
            </div>
            <div data-id="element-1756">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-1757">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1758">
                  <span className="sr-only" data-id="element-1759">Precedente</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1760">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-1761" />
                  </svg>
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1762">
                  1
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1763">
                  <span className="sr-only" data-id="element-1764">Successivo</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1765">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-1766" />
                  </svg>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
}